export default "__VITE_ASSET__3b79d330__"